import ko from "@/locales/ko/index";
import en from "@/locales/en/index";

export default {
    ko: ko,
    en: en,
};
